import { createContext, useContext, useEffect, useState, createElement } from "react";
import { client } from "@/lib/api";

const AuthContext = createContext(null);

export function useAuth() { return useContext(AuthContext); }

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => { client.get("/auth/me").then(r => setUser(r.data)).catch(() => setUser(false)).finally(() => setChecking(false)); }, []);
  const logout = async () => { await client.post("/auth/logout"); setUser(false); };
  if (checking) return createElement("div", { className: "loading-screen", "data-testid": "auth-loading" }, "Memeriksa sesi…");
  return createElement(AuthContext.Provider, { value: { user, setUser, logout } }, children);
}
